module.exports = __webpack_public_path__ + "static/media/stat-conjuntos.cf839462.png";